export default __webpack_public_path__ + "static/media/quotes.d8ff2524.png";